// Build URLs to external dictionaries for one-click verification of glossary
// terms and proper nouns. Lets translators sanity-check ChatsControl's choices
// against Multitran without leaving the app.

// ISO 639-1 → Multitran internal language ID.
// Reference: https://www.multitran.com/m.exe?a=1
const MULTITRAN_LANG_IDS = {
  en: 1,
  ru: 2,
  uk: 33,
  de: 3,
  fr: 4,
  es: 5,
  it: 23,
  pl: 30,
  nl: 24,
  pt: 8,
  ja: 28,
  zh: 17,
  el: 11,
  cs: 16,
  sv: 13,
  da: 25,
  fi: 36,
  hu: 9,
  no: 41,
  ro: 10,
  bg: 35,
  sr: 47,
  hr: 47, // Multitran groups them
  sk: 60,
  sl: 78,
  lv: 27,
  lt: 26,
  et: 26,
  tr: 12,
  ar: 14,
  he: 7,
  ko: 39,
  vi: 38,
  id: 76,
  th: 71,
};

const FALLBACK_LANG_IDS = { source: 1, target: 2 }; // English → Russian

export function buildMultitranUrl(term, sourceLang, targetLang) {
  if (!term) return null;
  const l1 = MULTITRAN_LANG_IDS[sourceLang] ?? FALLBACK_LANG_IDS.source;
  const l2 = MULTITRAN_LANG_IDS[targetLang] ?? FALLBACK_LANG_IDS.target;
  return `https://www.multitran.com/m.exe?s=${encodeURIComponent(term)}&l1=${l1}&l2=${l2}`;
}
